import UserInfo from './components/userInfo';
import NavSearch from './components/search';
import NavMenu from './components/navMenu';
import MyCompany from './components/myCompany';
import styles from './index.module.scss';
import type { SiderProps } from './type';

const AppNav = ({ collapse }: SiderProps) => {
  useEffect(() => {}, [collapse]);
  return (
    <div className={cls(styles.sider, collapse && styles.collapse)}>
      <div className={styles.infoAndSearch}>
        <UserInfo></UserInfo>
        <NavSearch collapse={collapse}></NavSearch>
      </div>
      <NavMenu className={styles.navMenu} collapse={collapse}></NavMenu>
      <MyCompany></MyCompany>
    </div>
  );
};

export default AppNav;
